export default "/_next/static/audios/be633aa1d63996dba16fba6c21d35297.mp3";